export default (id) => ({
  confirmed: false,
  id: id,
  confirm(e) {
    e.preventDefault();
    this.confirmed = true;
  },
  dismiss(e) {
    e.preventDefault();
    this.confirmed = false;
  },
});
